/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    import Utils = Common.Utils;

    export interface IDigicon  {
        id: number;
        status: string;
        name: string;
        matchDay: string;
        matchNumber: number;
        kit: number;
        mode: string;
        role: string;
        port: string;
        mainGateway: string;
        backupGateway: string;
    }

    export interface Port{
        id: Number;
        kit: String;
        name: String;
        state: String;
        phyName: String;
        update: String;
        txLimit: Number;
        rxLimit: Number;
        rxRate: Number;
        txRate: Number;
    }
    export interface kitInfo {
        name: String;
        matchDay: String;
        matchNumber: Number;
        mainKit: kitMainData;
        backupKit: kitMainData;
        kitId: Number;
        kitStatus: String;
        mode: String;
        role: String;
        port: String;
        mainGateway: String;
        backupGateway: String;
        trunkPort: Port;
        fileInPort: Port;
        TS360InPort: Port;
        ISOInPort: Port;
        EN07InPort: Port;
        EN08InPort: Port;
        sourceName?: String;
        sinkName?: String;
        type?: String;
    }

    export interface kitMainData {
        id: Number;
        status: String;
        rtt: Number;
    }
    

    export class Digicon implements IDigicon {
        public id: number;
        public status: string;
        public name: string;
        public matchDay: string;
        public matchNumber: number;
        public kit: number;
        public mode: string;
        public role: string;
        public port: string;
        public mainGateway: string;
        public backupGateway: string;




        public static Empty(): Digicon {
            return new Digicon();
        }

        public static Copy(digicon: Digicon): Digicon {
            let newDigicon: Digicon = new Digicon();
            newDigicon.id = digicon.id;
            newDigicon.name = digicon.name;
            newDigicon.matchDay = digicon.matchDay;
            newDigicon.status = digicon.status;
            newDigicon.matchNumber = digicon.matchNumber;
            newDigicon.kit = digicon.kit;
            newDigicon.mode = digicon.mode;
            newDigicon.role = digicon.role;
            newDigicon.mainGateway = digicon.mainGateway;
            newDigicon.backupGateway = digicon.backupGateway;
            return newDigicon;
        }

        constructor() {
            // empty constructor
            this.status = "";
            this.name = '';
            this.id = undefined;
            this.matchDay = '';
            this.matchNumber = undefined;
            this.kit = undefined;
            this.port = '';
            this.role = '';
            this.mode = '';
            this.backupGateway = 'None';
            this.mainGateway = 'None';

        }

        public matchesSearch(search: string): boolean {
            const searchText: string = this.name + this.kit + this.matchDay + this.mode + this.matchNumber + this.role + this.port + this.backupGateway + this.mainGateway;
            const regExp: RegExp = new RegExp(search, "ig");
            return regExp.test( searchText );
        }

    }
}
